import { useState } from 'react'
import {MessageCircleDashed as MessageCircle, X, Send} from 'lucide-react'

interface ChatMessage {
  id: number
  from: 'user' | 'agent'
  text: string
}

const initialMessages: ChatMessage[] = [
  { id: 1, from: 'agent', text: 'Olá! 👋 Sou o assistente virtual da Site Consultoria Tech. Como posso ajudar com sua necessidade de segurança hoje?' },
]

function LiveChatWidget() {
  const [open, setOpen] = useState(false)
  const [messages, setMessages] = useState<ChatMessage[]>(initialMessages)
  const [input, setInput] = useState('')

  const handleSend = (e: React.FormEvent) => {
    e.preventDefault()
    const text = input.trim()
    if (!text)
      return

    const userMessage: ChatMessage = { id: Date.now(), from: 'user', text }
    setMessages(prev => [...prev, userMessage])
    setInput('')

    setTimeout(() => {
      setMessages(prev => [
        ...prev,
        {
          id: Date.now() + 1,
          from: 'agent',
          text: 'Obrigado pelo contato! Um de nossos especialistas retornará em breve. Você também pode preencher nosso formulário de consultoria para agilizar o atendimento.',
        },
      ])
    }, 900)
  }

  return (
    <div className="fixed bottom-5 right-5 z-50">
      {open ? (
        <div className="mb-3 flex h-96 w-80 flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-2xl sm:w-96">
          <div className="flex items-center justify-between bg-slate-900 px-4 py-3">
            <span className="text-sm font-semibold text-white">Fale com um especialista</span>
            <button type="button" onClick={() => setOpen(false)} aria-label="Fechar chat" className="text-slate-300 hover:text-white">
              <X className="h-4 w-4" aria-hidden="true" />
            </button>
          </div>
          <div className="flex-1 space-y-3 overflow-y-auto p-4">
            {messages.map(msg => (
              <div
                key={msg.id}
                className={`max-w-[85%] rounded-xl px-3 py-2 text-sm leading-relaxed ${
                  msg.from === 'agent'
                    ? 'bg-slate-100 text-slate-800'
                    : 'ml-auto bg-cyan-600 text-white'
                }`}
              >
                {msg.text}
              </div>
            ))}
          </div>
          <form onSubmit={handleSend} className="flex items-center gap-2 border-t border-slate-100 p-3">
            <label htmlFor="chat-input" className="sr-only">Mensagem</label>
            <input
              id="chat-input"
              type="text"
              value={input}
              onChange={e => setInput(e.target.value)}
              placeholder="Digite sua mensagem..."
              className="flex-1 rounded-lg border border-slate-200 px-3 py-2 text-sm outline-none focus:border-cyan-500 focus:ring-1 focus:ring-cyan-500"
            />
            <button
              type="submit"
              aria-label="Enviar mensagem"
              className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-cyan-600 text-white hover:bg-cyan-700"
            >
              <Send className="h-4 w-4" aria-hidden="true" />
            </button>
          </form>
        </div>
      ) : null}

      <button
        type="button"
        onClick={() => setOpen(v => !v)}
        aria-label={open ? 'Fechar chat ao vivo' : 'Abrir chat ao vivo'}
        className="flex h-14 w-14 items-center justify-center rounded-full bg-cyan-600 text-white shadow-lg transition-transform hover:scale-105 hover:bg-cyan-700"
      >
        {open ? <X className="h-6 w-6" aria-hidden="true" /> : <MessageCircle className="h-6 w-6" aria-hidden="true" />}
      </button>
    </div>
  )
}

export default LiveChatWidget
